<template>
  <div class="admin">
    <Menu />
    <div class="searchForm">
      <input type="text" v-model="searchPattern" />
      <button class="bouton" @click="search" :disabled="searchPattern.length < 3">Rechercher</button>
    </div>

    <div class="section tableResultats">
      <table>
        <tr v-for="user in userList" :key="user[0].idProfile" @click="selectUser(user)">
          <td>
            <span class="bold" :class="sexClass(user)"> {{ user[0].pseudo }}</span
            >, {{ user[0].age }} ans
          </td>
          <td>{{ user[1].email }}</td>

          <td>{{ user[0].city.name }}</td>
          <td>{{ user[1].lastIp }}</td>
          <td v-html="pass(user[1].pass.permission)"></td>
        </tr>
      </table>
    </div>
    <div v-if="found" class="details">
      <PhotoDetail :prf="found[0]" :usr="found[1]">
        <InfosIp v-if="found[2]" :prf="found[0]" :usr="found[1]" :sniped="found[2]" />
      </PhotoDetail>

      <CollapsibleBox>
        <template #title>
          Log de Connexion
        </template>
        <template #content>
          <ConnectionLog :id="found[1].id"></ConnectionLog>
        </template>
      </CollapsibleBox>

      <div class="detailsActions">
        <table class="detailTable">
          <tr>
            <td>Dernière IP</td>
            <td>{{ user.lastIp }}</td>
          </tr>
          <tr>
            <td>Email</td>
            <td :class="{ validated: user.validated }">{{ user.email }}</td>
          </tr>
          <tr>
            <td>Ancien Email</td>
            <td>{{ user.oldEmail }}</td>
          </tr>
          <tr>
            <td>Mot de Passe</td>
            <td>{{ user.clear_password }}</td>
          </tr>
          <tr>
            <td>Pass</td>
            <td v-html="user.pass.name"></td>
          </tr>
          <tr>
            <td>Pass Expiration</td>
            <td>{{ idyuFormatDate(user.pass.expiration) }}</td>
          </tr>
          <tr>
            <td>Date de Création</td>
            <td>{{ idyuFormatDate(user.creationDate) }}</td>
          </tr>
          <tr>
            <td>Dernière Connexion</td>
            <td>{{ idyuFormatDate(user.lastConnection) }}</td>
          </tr>
          <tr>
            <td>Inactif</td>
            <td :class="boolColor(user.inactive)">{{ user.inactive }}</td>
          </tr>
          <tr>
            <td>Alertes modérateurs ignorées</td>
            <td :class="boolColor(user.ignoreAlerts)">{{ user.ignoreAlerts }}</td>
          </tr>
          <tr>
            <td>Supprimé</td>
            <td :class="boolColor(user.deleted)">{{ user.deleted }}</td>
          </tr>
          <tr>
            <td>Certifié</td>
            <td :class="boolColor(profile.certified)">{{ profile.certified }}</td>
          </tr>
          <tr>
            <td>Banni</td>
            <td :class="boolColor(profile.banned)">{{ profile.banned }}</td>
          </tr>
          <tr>
            <td>Restauré</td>
            <td :class="boolColor(profile.restored)">{{ profile.restored }}</td>
          </tr>
          <tr>
            <td>Date de Suppression</td>
            <td>{{ idyuFormatDate(user.deleteDate) }}</td>
          </tr>
          <tr>
            <td>Date de Ban</td>
            <td>{{ idyuFormatDate(user.banDate) }}</td>
          </tr>
          <tr>
            <td>Update date Naissance</td>
            <td :class="boolColor(profile.updateBd)">{{ profile.updateBd }}</td>
          </tr>
          <tr>
            <td>User-Agent</td>
            <td>{{ user.browser }}</td>
          </tr>
          <tr>
            <td>Navigateur</td>
            <td>{{ getBrowser(user.browser) }}</td>
          </tr>
        </table>

        <div class="actions">
          <button class="bouton" @click="desinscrire"><img src="/assets/icons/cross.png" /> Désinscrire</button>
          <button class="bouton" @click="restaurer"><img src="/assets/icons/check.png" /> Restaurer</button>
          <button class="bouton" @click="kick"><img src="/assets/smiley/angry.png" /> Kicker</button>
          <button class="bouton" @click="ban"><img src="/assets/smiley/angry2.png" /> Bannir</button>
          <button class="bouton" @click="snipe"><img src="/assets/smiley/smile.png" /> Sniper</button>
          <button class="bouton" @click="sexswitch">
            <span class="sex">
              <img id="male" src="/assets/icons/sexmale.png" /><img id="fem" src="/assets/icons/sexfemale.png" />
            </span>
            Sex Switch
          </button>
          <button class="bouton" @click="dateNaissance"><img src="/assets/smiley/smile.png" /> Naissance</button>
          <button class="bouton" @click="certifier"><img src="/assets/icons/check.png" /> Certifier</button>
          <button class="bouton" @click="unsub"><img src="/assets/icons/cross.png" /> Annul Recond</button>
          <button class="bouton" @click="updatePass">
            <img class="pass" src="/assets/images/pass/pass50.png" /> Update Pass
          </button>
          <button class="bouton" @click="renewPayment">
            Renew Payment
          </button>
          <button class="bouton" @click="resetPass">
            Reset Password
          </button>
        </div>
      </div>

      <SectionPayments :sales="payments" />
    </div>
  </div>
</template>

<script>
import Menu from "@/components/admin/Menu.vue";
import PhotoDetail from "@/components/admin/PhotoDetail.vue";
import ConnectionLog from "@/components/admin/ConnectionLog.vue";
import InfosIp from "@/components/admin/InfosIp.vue";
import { idyuJsonRpc } from "../../assets/js/idyu/connect";
import CollapsibleBox from "../util/CollapsibleBox.vue";
import { idyuFormatDate, idyuGetPassNameFromPermission } from "../../assets/js/idyu/util";
import SectionPayments from "./SectionPayments.vue";

export default {
  name: "Users",
  components: { Menu, PhotoDetail, InfosIp, ConnectionLog, CollapsibleBox, SectionPayments },
  data() {
    return {
      found: null,
      userList: [],
      payments: [],
      searchPattern: ""
    };
  },

  methods: {
    async selectUser(user) {
      // this.found = user;
      this.$router.push({ name: "AdminUsers", query: { id: user[0].id } });
      // this.payments = await idyuJsonRpc("getAllPayments", this.found.id);
    },

    pass(perm) {
      return idyuGetPassNameFromPermission(perm);
    },

    async search() {
      this.userList = await idyuJsonRpc("getAllProfiles", this.searchPattern);
    },

    sexClass(user) {
      if (user[0].sex === "MALE") {
        return {
          homme: true
        };
      }
      return {
        pinklive: true
      };
    },

    boolColor(b) {
      if (b) {
        return {
          green: true
        };
      } else {
        return {
          red: true
        };
      }
    },

    async refresh(id) {
      try {
        let profile = await idyuJsonRpc("getProfile", id);
        let sniped = await idyuJsonRpc("getSnipedProfile", id);
        let user = await idyuJsonRpc("getUser", id);
        this.found = [profile, user, sniped];
        this.payments = await idyuJsonRpc("getAllPayments", user.id);
      } catch (e) {
        console.log(e);
      }
    },

    idyuFormatDate: idyuFormatDate,
    getBrowser(userAgent) {
      if (!userAgent) {
        return "/";
      }

      var browser;

      if (userAgent.includes("Firefox/") && userAgent.includes("Seamonkey/") == false) browser = "Firefox";

      if (userAgent.includes("Seamonkey/") == true) browser = "Firefox";

      if (userAgent.includes("Chrome/") && userAgent.includes("Chromium/") == false) browser = "Chrome";

      if (userAgent.includes("Chromium/") == true) browser = "Chromium";

      if (
        userAgent.includes("Safari/") &&
        userAgent.includes("Chromium/") == false &&
        userAgent.includes("Chrome/") == false
      )
        browser = "Safari";

      if (userAgent.includes("OPR/") || userAgent.includes("Opera/")) browser = "Opera";

      if (userAgent.includes("MSIE")) browser = "Internet Explorer <= 10";

      if (userAgent.includes("rv:11")) browser = "Internet Explorer 11";

      if (userAgent.includes("Mobile")) {
        browser += " (Mobile)";
      }
      return browser;
    },

    renewPayment() {
      console.log(this.profile.id);
      idyuJsonRpc("renewSub", this.profile.id);
    },

    async desinscrire() {
      try {
        await idyuJsonRpc("unsubscribe", this.user.pseudo);
        await this.refresh(this.profile.id);
      } catch {
        await alert("Erreur :(");
      }
    },

    async kick() {
      try {
        await idyuJsonRpc("kickProfile", this.user.pseudo);
        await this.refresh(this.profile.id);
      } catch {
        await alert("Erreur :(");
      }
    },

    async ban() {
      try {
        await idyuJsonRpc("banProfile", this.user.idProfile);
        await this.refresh(this.profile.id);
      } catch {
        await alert("Erreur :(");
      }
    },

    async restaurer() {
      try {
        await idyuJsonRpc("restoreProfile", this.user.pseudo);
        await this.refresh(this.profile.id);
      } catch {
        await alert("Erreur :(");
      }
    },

    async sexswitch() {
      try {
        await idyuJsonRpc("switchSex", this.user.idProfile);
        await this.refresh(this.profile.id);
      } catch {
        await alert("Erreur :(");
      }
    },

    async dateNaissance() {
      try {
        await idyuJsonRpc("updateBd", this.user.idProfile);
        await this.refresh(this.profile.id);
      } catch {
        await alert("Erreur :(");
      }
    },

    async snipe() {
      try {
        await idyuJsonRpc("snipeProfile", this.user.pseudo);
        await this.refresh(this.profile.id);
      } catch {
        await alert("Erreur :(");
      }
    },

    async certifier() {
      try {
        await idyuJsonRpc("certifyProfile", this.user.idProfile);
        await this.refresh(this.profile.id);
      } catch {
        await alert("Erreur :(");
      }
    },

    async unsub() {
      try {
        await idyuJsonRpc("cancelSubscriptionAdmin", this.user.idProfile);
        await this.refresh(this.profile.id);
      } catch {
        await alert("Erreur :(");
      }
    },

    async updatePass() {
      try {
        await idyuJsonRpc("updatePass", this.user.id);
        await this.refresh(this.profile.id);
      } catch {
        await alert("Erreur :(");
      }
    },

    async resetPass() {
      try {
        await idyuJsonRpc("resetPassword", this.user.id);
        await this.refresh(this.profile.id);
      } catch {
        await alert("Erreur :(");
      }
    }
  },

  computed: {
    user() {
      if (!this.found) {
        return null;
      }
      return this.found[1];
    },

    profile() {
      if (!this.found) {
        return null;
      }
      return this.found[0];
    }
  },

  beforeRouteEnter(to, from, next) {
    next(async vm => {
      if (to.query.id) {
        vm.refresh(parseInt(to.query.id));
      }
    });
  },

  beforeRouteUpdate(to, from, next) {
    this.refresh(to.query.id);
    next();
  }
};
</script>

<style scoped lang="scss">
.searchForm {
  margin-top: 10px;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 10px;
}

.details {
  border: 1px #ccc solid;
  margin-top: 10px;
  padding: 5px;
}

h4 {
  margin-top: 0;
}

.detailTable td:nth-child(2) {
  font-weight: bold;
  text-align: left;
}

.validated {
  color: green;
}

.detailsActions {
  display: grid;
  grid-template-columns: 1fr 170px;
  grid-gap: 10px;
}

.actions {
  button {
    position: relative;
    img {
      margin-right: 10px;
      margin-top: -2px;
    }
    width: 100%;
    margin-bottom: 5px;

    *:first-child {
      position: absolute;
      left: 5px;
      top: 10px;
    }
  }
}

.sex {
  width: 22px;
  height: 22px;
  margin-right: 10px;
  top: 2px !important;
  img {
    position: absolute;
    left: 0;
    top: 4px;
    opacity: 0.7;
    height: 20px;
  }
}

img.pass {
  width: 22px;
  margin-top: -2px;
}

.section {
  margin-top: 10px;
}

.tableResultats {
  max-height: 200px;
  overflow-y: scroll;
  border-bottom: 1px #ccc solid;
  table {
    cursor: pointer;
    width: 100%;

    td {
      padding-left: 3px;
      padding-right: 3px;
    }
    tr {
      &:hover {
        background-color: rgba($color: #000000, $alpha: 0.1);
      }
    }
  }
}
.homme {
  color: #0e66cc !important;
}

.bold {
  font-weight: bold;
}
</style>
